import { Navigate, Outlet } from "react-router-dom";
import Header from "../_components/common/Header";

const ProtectedRoutesOutlet = () => {
  const auth = { token: localStorage.getItem('access_token_AS') };
  // const auth = { token: "Authenticated" };
  // const auth = { token: null };
  return auth.token ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      <header className="App-header">
        <Header />
      </header>
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutesOutlet;
